module.exports = __webpack_public_path__ + "img/paper.6b17eee9.svg";